import * as React from 'react';
import { useEffect } from 'react';
import { useFilterParamsContext } from '../../model/filter_params';

/**
 * @typedef {Object} FilterTag
 * @property {id} number
 * @property {name} string
 */

/**
 * @param {Object} props
 * @param {string} filterParamsProperty
 * @param {Array<number>} selectedTagsIds
 * @param {(tagId: number, allTags: Array) => void} onRemoveTag
 * @return {React.JSX.Element | Array<React.JSX.Element> | undefined}
 * @constructor
 */
export const SelectedFilterTags = ({ selectedTagsIds, filterParamsProperty, onRemoveTag }) => {
  const { filterParams } = useFilterParamsContext();
  const allTags = filterParams[filterParamsProperty] ?? [];

  if (!allTags || !Array.isArray(selectedTagsIds)) return;

  return selectedTagsIds.map((id) => (
    <div
      className={'filter-tags-list__tag filter-tags-list__tag_prevent-remove'}
      onClick={() => onRemoveTag(id, selectedTagsIds)}
      key={id}
    >
      {allTags.find((tag) => tag.id == id)?.name}
    </div>
  ));
};
